"use strict";
const _ = require("lodash");
var HEURISTICS;
(function (HEURISTICS) {
    HEURISTICS.POINT_COUNT = function (pattern, vectors, occurrences, allPoints) {
        return pattern.length;
    };
    HEURISTICS.COVERAGE = function (pattern, vectors, occurrences, allPoints) {
        var stringOcc = occurrences.map(occ => occ.map(p => JSON.stringify(p)));
        var uniquePoints = _.uniq(_.flatten(stringOcc));
        return uniquePoints.length / allPoints.length;
    };
    HEURISTICS.COMPACTNESS = function (pattern, vectors, occurrences, allPoints) {
        return 1 / getPointsInBoundingBox(pattern, allPoints).length;
    };
    HEURISTICS.COMPACTNESS2 = function (pattern, vectors, occurrences, allPoints) {
        return 1 / (1 + getPointsInBoundingBox(pattern, allPoints).length - pattern.length);
    };
    function getPointsInBoundingBox(pattern, allPoints) {
        var maxes = _.zip(...pattern).map(c => _.max(c));
        var mins = _.zip(...pattern).map(c => _.min(c));
        return allPoints.filter(p => p.every((e, i) => maxes[i] - mins[i] == 0 || (mins[i] <= e && e <= maxes[i])));
    }
})(HEURISTICS = exports.HEURISTICS || (exports.HEURISTICS = {}));



//////////////////
// WEBPACK FOOTER
// ./~/siafun/lib/heuristics.js
// module id = 819
// module chunks = 3